import { createRouter, createWebHashHistory } from 'vue-router'
import Accounting from '../views/AccountingView.vue'
const routes = [
    {
        path:'/accounting-view',
        name:'accounting',
        component:Accounting
    },
]
const router = createRouter({
    history:createWebHashHistory(),
    routes
})
export default router
